import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPackage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "package",
		children: /* @__PURE__ */ _jsx("path", {
			id: "package_2",
			d: "M13.7845 3.99396L8.71249 1.05429C8.52617 0.950777 8.29845 0.888672 8.09143 0.888672C7.88441 0.888672 7.65669 0.950777 7.47037 1.05429L2.3984 3.99396C2.00506 4.22168 1.77734 4.63572 1.77734 5.07046V10.9291C1.77734 11.3638 2.00506 11.7779 2.3984 12.0056L7.47037 14.9453C7.65669 15.0488 7.88441 15.1109 8.09143 15.1109C8.29845 15.1109 8.52617 15.0488 8.71249 14.9453L13.7845 12.0056C14.1778 11.7779 14.4055 11.3638 14.4055 10.9291V5.07046C14.4055 4.61502 14.1778 4.20098 13.7845 3.99396ZM8.09143 2.13079L12.563 4.69783L8.09143 7.28557L3.64052 4.69783L8.09143 2.13079ZM3.01946 5.77433L7.47037 8.36207V13.5168L3.01946 10.9291V5.77433ZM8.71249 13.5168V8.36207L13.1634 5.79503V10.9498L8.71249 13.5168Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgPackage);
export { ForwardRef as ReactComponent };
